import { createFileRoute } from "@tanstack/react-router";
import AdminTagDetailPage from "@/pages/admin/tags/detail";
import { useTagsPermissions } from "@/pages/admin/tags";

export const Route = createFileRoute("/app/admin/tags/$tagId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { tagId } = Route.useParams();
  const { userCanEditAllTags, userCanViewAllTags } = useTagsPermissions();

  return (
    <AdminTagDetailPage
      tagId={tagId}
      userCanEditAllTags={userCanEditAllTags}
      userCanViewAllTags={userCanViewAllTags}
    />
  );
}
